import React, { FunctionComponent } from 'react';
import { ButtonBase, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { links } from '/src/domain/shared/links';

interface ViewTrackButtonData {
    trackId: string;
}

const ViewTrackButton: FunctionComponent<ViewTrackButtonData> = ({ trackId }) => {
    const { t } = useTranslation()
    const classes = useStyles()

    if (!trackId) return null;

    return (
        <Link href={`${links.origin}/activity?aid=${trackId}`}
            className={classes.stravaLink}
            target="_blank"
            rel="noopener"
        >
            <ButtonBase className={classes.viewTrackButton}>
               {t('watchTrack')}
            </ButtonBase>
        </Link>
    )
}

const useStyles = makeStyles(muiTheme => ({
    stravaLink: {
        display: 'block'
    },
    viewTrackButton: {
        width: '100%',
        height: '2.7rem',
        color: muiTheme.palette.primary.main,
        fontWeight: 500,
        backgroundColor: muiTheme.palette.primary.contrastText,
        borderRadius: '4px',
        boxShadow: '0 2px 7px rgb(0, 0, 0, 0.3)'
    },
}))


export default ViewTrackButton
